import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';

import { MainComponent } from './templates/main/main.component';
import { MainAuthenticationComponent } from './templates/main-authentication/main-authentication.component';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderSectionComponent } from './components/header-section/header-section.component';
import { SpinnerComponent } from './components/spinner/spinner.component';

import { HomeComponent } from './pages/home/home.component';
import { NotAvailableComponent } from './pages/not-available/not-available.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';


@NgModule({

    declarations: [

        MainComponent,
        MainAuthenticationComponent,

        HomeComponent,
        NotAvailableComponent,
        NotFoundComponent,

        HeaderComponent,
        FooterComponent,
        HeaderSectionComponent,
        SpinnerComponent

    ],

    imports: [

        CommonModule,
        SharedModule

    ],

    exports: [

        MainComponent,
        MainAuthenticationComponent,

        HeaderSectionComponent,
        SpinnerComponent

    ]

})
export class TemplateModule { }
